import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { CODE_STATUS } from '@app/constant/CodeConstant'
import { STATUS } from '@app/constant/StatusConstant'
import { usePage } from '@inertiajs/inertia-react'
import { useTranslation } from 'react-i18next'

export default function VoucherCode() {
  const {
    props: { codes, voucher, routeName },
  } = usePage()

  const { t } = useTranslation()

  return (
    <Section simple>
      <DataGrid
        enableIndexColumn
        columns={[
          {
            id: 'code',
            accessor: 'code',
            Header: t('CODES.ID'),
            type: 'string',
          },
          {
            id: 'status',
            Header: t('CODES.STATUS'),
            accessor: ({ status }) => t(`CODES.${status.toUpperCase()}`),
            type: 'singleSelect',
            width: 70,
            options: [
              { value: STATUS.AVAILABLE, name: t(`CODES.${STATUS.AVAILABLE_NAME.toUpperCase()}`) },
              { value: CODE_STATUS.REDEEMED, name: t(`CODES.${CODE_STATUS.REDEEMED_NAME.toUpperCase()}`) },
              { value: CODE_STATUS.USED, name: t(`CODES.${CODE_STATUS.USED_NAME.toUpperCase()}`) },
            ],
          },
        ]}
        data={codes}
        enableCollapseFilter={false}
        params={{ merchant: voucher.merchant_id, voucher: voucher.id, tab: 'codes' }}
        queries={{
          merchant: voucher.merchant_id,
          voucher: voucher.id,
          tab: 'codes',
        }}
        routeName={routeName}
      />
    </Section>
  )
}
